export const MultiFiles = ({
  size = "24",
  ...props
}: { size?: string } & React.SVGProps<SVGSVGElement>) => {
  return (
    <>
      <span className="t-sr-only">Multi Files</span>
      <svg
        {...props}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.192 18.6091H4.53344C4.36166 18.6091 4.19692 18.5391 4.07545 18.4145C3.95398 18.2898 3.88574 18.1208 3.88574 17.9445V3.32306C3.88574 3.14679 3.95398 2.97775 4.07545 2.85311C4.19692 2.72847 4.36166 2.65845 4.53344 2.65845H12.3058L16.8397 7.31073V17.9445C16.8397 18.1208 16.7715 18.2898 16.65 18.4145C16.5286 18.5391 16.3638 18.6091 16.192 18.6091Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9824 2.65845V7.64303H16.8402"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.4655 21.3415H7.80688C7.6351 21.3415 7.47035 21.2715 7.34889 21.1469C7.22742 21.0222 7.15918 20.8532 7.15918 20.6769V6.05548C7.15918 5.87921 7.22742 5.71017 7.34889 5.58553C7.47035 5.46089 7.6351 5.39087 7.80688 5.39087H15.5793L20.1132 10.0431V20.6769C20.1132 20.8532 20.0449 21.0222 19.9235 21.1469C19.802 21.2715 19.6373 21.3415 19.4655 21.3415Z"
          fill="white"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.2559 5.39087V10.3755H20.1136"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
